import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams, Link } from 'react-router-dom';
import { connect, useDispatch } from 'react-redux';
import { history } from '../../history';
import { Modal } from 'react-bootstrap';
import { InstallationAction, ErrorCodeAction, ProductAction } from '../../actions';
import { AppHeader } from '../../components/common/LeftMenu';
import { Translate as t } from '../../config/Translate';
import { InstallationConstant } from '../../actions/constants/InstallationConstant';
import { Loading } from '../../components/common/Loading';
import InstallationStep0 from '../../components/installation/InstallationStep0';
import InstallationStep1 from '../../components/installation/InstallationStep1';
import InstallationStep2 from '../../components/installation/InstallationStep2';
import InstallationStep3 from '../../components/installation/InstallationStep3';
import InstallationStep4 from '../../components/installation/InstallationStep4';
import InstallationStep5 from '../../components/installation/InstallationStep5';
import InstallationStep6 from '../../components/installation/InstallationStep6';
import InstallationStep7 from '../../components/installation/InstallationStep7';

const Installation = ({ Get, GetProduct, installation, product, Update, user }) => {

	const dispatch = useDispatch();
	const { _id, view } = useParams();
	const [step, setStep] = useState(1);
	const [gostep, setGoStep] = useState({
		curStep: 100,
		goStepNo: 0
	});

	// 기존 설치 보고서를 읽는 동안 표시 — InstallationReducer.isLoading 은 단계 저장과 공유돼(단계 화면이 언마운트됨) 쓰지 않는다.
	const [fetching, setFetching] = useState(!!_id);
	const aliveRef = useRef(true);

	//const [t, i18n] = useTranslation();

	useEffect(() => {
		aliveRef.current = true;
		if (_id) {
			// 직전에 본 보고서가 남지 않게 비운 뒤 읽는다(실패해도 이전 보고서가 보이지 않음).
			dispatch({ type: InstallationConstant.GET_INSTALLATION, installation: {} });
			Promise.resolve(Get(_id)).finally(() => {
				if (aliveRef.current) setFetching(false);
			});
		} else {
			dispatch({ type: InstallationConstant.NEW });
		}
		return () => { aliveRef.current = false; };
	}, [])

	useEffect(() => {
		setStep(installation.installationStep);
		if (installation.sn) {
			GetProduct(installation.sn);
		}
		setGoStep({
			curStep: 100,
			goStepNo: 0
		});
	}, [installation])

	// 기존 보고서(_id)를 읽었는데 비어 있으면(조회 실패) 빈 양식을 그리지 않는다. 실패 알림은 액션이 띄운다.
	const loadFailed = !!_id && !fetching && !installation?._id;

	const goStep = (num, addminus) => {
		// 단계 번호만 저장하면 입력이 버려진다 → SiteSurvey 와 같은 규칙: 이동은 gostep 으로 요청만 하고,
		// 각 Step 컴포넌트가 자기 검증을 통과하면 현재 입력과 함께 저장한다.
		// 배지 클릭은 addminus '' 로 해당 단계, ◀▶ 는 한 칸. 범위 1~8, 마지막 서명·제출 단계(8)로 바로 가기 금지.
		const target = Math.min(8, Math.max(1, Number(num) + (addminus || 0)));
		if (Number.isFinite(target) && target != 8) {
			setGoStep({
				curStep: step,
				goStepNo: target
			});
		}
	}

	const getHeaderStep = () => {
		const rows = [];
		for (let i = 1; i <= 8; i++) {
			if (step == i) {
				rows.push(<a className="badge badge-primary me-05" href onClick={(e) => goStep(e.target.title, '')} title={i}>{' '}</a>);
			} else {
				rows.push(<a className="badge badge-secondary me-05" href onClick={(e) => goStep(e.target.title, '')} title={i}>{' '}</a>);
			}
		}
		return rows;
	}

	return (
		<>
			<div className="appHeader no-border bg-white">
				<div className="left">
					<a href onClick={() => history.goBack()} className="headerButton goBack">
						<ion-icon name="chevron-back-outline" role="img" className="md hydrated" aria-label="chevron back outline"></ion-icon>
					</a>
					<div className="pageTitle">
						{t('installation.label.installReport')}
						{(installation._id && installation.siteName) && " : " + installation.siteName}
					</div>
				</div>
				<div className="right">
				</div>
			</div>
			<div className="extraHeader full-width step-title">
				{installation._id && <div className="section-title fl">
					{(view != "view" && step > 1) && <a onClick={() => goStep(step, -1)} className="text-primary btn-sm"><ion-icon name="caret-back-outline" role="img" className="md hydrated" aria-label="caret back outline"></ion-icon></a>}
				</div>}
				<div className="text-center step-badge">
					<h3 style={{ marginBottom: "5px" }}>Step {step}</h3>
					{getHeaderStep()}
				</div>
				{installation._id && <div className="section-title fr">
					{(view != "view" && step < 8) && <a onClick={step < 7 ? () => goStep(step, 1) : undefined} aria-disabled={step >= 7} className="text-secondary btn-sm" style={step >= 7 ? { opacity: 0.35, cursor: "not-allowed" } : undefined}><ion-icon name="caret-forward-outline" role="img" className="md hydrated" aria-label="caret forward outline"></ion-icon></a>}
				</div>}
			</div>
			<div id="appCapsule" className="extra-header-active full-height">
				{fetching && <div className="mt-3"><Loading /></div>}
				{!fetching && !loadFailed && view == "view" && <InstallationStep7 info={installation} product={product} view="view" />}
				{!fetching && !loadFailed && view != "view" &&
					<>
						{(step === 1 && !installation._id) && <InstallationStep0 info={installation} gostep={gostep.curStep == 1 && gostep} />}
						{(step === 1 && installation._id) && <InstallationStep0 info={installation} product={product} gostep={gostep.curStep == 1 && gostep} />}
						{step === 2 && <InstallationStep1 info={installation} product={product} gostep={gostep.curStep == 2 && gostep} />}
						{step === 3 && <InstallationStep2 info={installation} product={product} gostep={gostep.curStep == 3 && gostep} />}
						{step === 4 && <InstallationStep3 info={installation} product={product} gostep={gostep.curStep == 4 && gostep} />}
						{step === 5 && <InstallationStep4 info={installation} product={product} gostep={gostep.curStep == 5 && gostep} />}
						{step === 6 && <InstallationStep5 info={installation} product={product} gostep={gostep.curStep == 6 && gostep} />}
						{step === 7 && <InstallationStep6 info={installation} product={product} gostep={gostep.curStep == 7 && gostep} />}
						{step === 8 && <InstallationStep7 info={installation} product={product} gostep={gostep.curStep == 8 && gostep} />}
					</>
				}
			</div>
		</>
	);
};

const mapState = (state) => {
	const installation = state.InstallationReducer.installation;
	const product = state.ProductReducer.product;
	const user = state.AuthReducer.user;
	return { installation, product, user };
}

const mapDispatch = (dispatch) => ({
	GetProduct: (sn) => dispatch(ProductAction.GetProduct(sn)),
	Create: (data) => dispatch(InstallationAction.CreateInstallation(data)),
	Get: (_id) => dispatch(InstallationAction.GetInstallation(_id)),
	Update: (_id, data) => dispatch(InstallationAction.UpdateInstallation(_id, data)),
});

export default connect(mapState, mapDispatch)(Installation);